import React, { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { ChevronDown, ChevronRight } from 'lucide-react';

export const KPICard = ({ label, value, sublabel, color }) => (
  <div className="p-4 rounded-lg bg-muted/30">
    <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">{label}</p>
    <p className={`font-bold text-xl ${color === 'stable' ? 'text-stable' : color === 'destructive' ? 'text-destructive' : 'text-foreground'}`}>{value}</p>
    {sublabel && <p className="text-xs text-muted-foreground mt-1">{sublabel}</p>}
  </div>
);

export const CollapsibleSection = ({ title, icon: Icon, children, defaultOpen, badge }) => {
  const [open, setOpen] = useState(defaultOpen !== false);
  return (
    <div className="mb-6">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4 bg-card border border-border/50 rounded-lg hover:border-primary/30">
        <div className="flex items-center gap-3">
          {Icon && <Icon className="w-5 h-5 text-primary" />}
          <span className="text-sm font-semibold uppercase tracking-wider">{title}</span>
          {badge && <Badge variant="outline" className="text-xs">{badge}</Badge>}
        </div>
        {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
      </button>
      {open && <div className="mt-3 p-5 bg-card border border-border/50 rounded-lg">{children}</div>}
    </div>
  );
};

export const ProfileSelector = ({ activeProfile, profiles, onProfileChange }) => (
  <div className="flex gap-2 mb-6">
    {Object.entries(profiles).map(([id, profile]) => (
      <button key={id} onClick={() => onProfileChange(id)} className={`px-4 py-2 rounded-lg text-sm font-medium ${activeProfile === id ? 'bg-primary text-primary-foreground' : 'bg-muted/50 text-muted-foreground hover:bg-muted'}`}>
        {profile.name}
      </button>
    ))}
  </div>
);

export const formatCurrency = (v) => v >= 1000000 ? `$${(v/1000000).toFixed(1)}M` : v >= 1000 ? `$${(v/1000).toFixed(0)}K` : `$${v}`;
